import { styled, Tab as TabMui } from "@mui/material";

export const Tab = styled(TabMui)(() => ({
  margin: "0 12px",
}));
